import { render, staticRenderFns } from "./BaseStaticField.vue?vue&type=template&id=b126d18c&"
import script from "./BaseStaticField.vue?vue&type=script&lang=js&"
export * from "./BaseStaticField.vue?vue&type=script&lang=js&"
import style0 from "./BaseStaticField.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "BaseStaticField.vue"
export default component.exports